<template>
    <section id="performers">
        <div class="container">
            <div class="secondary-heading text-center">ESSENS KICK OFF</div>
            <h1 class="text-center mb-5"> {{ $t('webUcinkujici') }} </h1>
            <div class="row">
                <template v-for="performer in performers" :key="performer">
                    <template v-if="!performer.rusOnly">
                        <Performer :performer="performer"/>
                    </template>
                    <!-- Rusák navíc jen v Ruštině 
                    <template v-if="locale == 'ru' && performer.rusOnly">
                        <Performer :performer="performer"/>
                    </template>-->
                </template>
            </div>
        </div>
    </section>
</template>

<script setup>
    import Performer from '@/components/homepage/onePerformer.vue'
    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();

    const performers = [
        {name: 'Natalia Limar', txtKey: 'web2026RLimarT' },
        {name: 'Dmitrii Vasiliev', txtKey: 'web2026RVasT' },
        {name: 'DJ SMASH', txtKey: 'web2026RDjT' },
    ]
</script>

<style>
    #performers {
        background-color: var(--grey-bg);
    }

    .performer {
        padding: 15px;
        margin-bottom: 3rem;
        text-align: center;
        transition: .5s;
    }

    .performer .job {
        color: var(--secondary);
    }

    .performer:hover {
        background-color: white;
        box-shadow: 0px 0px 10px #0000000f;
    }

    .performer img {
        margin-bottom: 1rem;
    }

    .performer .txt {
        margin-top: 1rem;
        text-align: justify;
    }

    .performer .border-y {
        border: solid 3px transparent;
        border-left-color: var(--secondary) !important;
        padding-left: 15px;
    }

    .performer .left-side {
        min-width: 250px;
    }

    @media (min-width: 992px) {
        .performer {
            padding-right: 3rem !important;
        }
    }
</style>